<script setup lang="ts">
import type { StatusKey } from './icons';

const props = withDefaults(defineProps<{
  status?: StatusKey;
  size?: 'sm' | 'lg' | 'xl';
  pulse?: boolean;
}>(), {
  status: 'online',
  size: 'sm',
  pulse: false,
});
</script>

<template>
  <span
    :class="['signal-dot', status, size === 'lg' ? 'lg' : '', size === 'xl' ? 'xl' : '', pulse ? 'pulse' : '']"
    :style="pulse ? { position: 'relative' } : undefined"
  />
</template>
